import { setEvoCentralInstances } from '../../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { DiscoveryApiClient } from '../DiscoveryApiClient';
import type {
    APIDiscoveryV2,
    APIDiscoveryV2Response,
    EvoCentralInstance,
    EvoCentralInstances,
} from './Discovery.types';

// Only Evo instances that include "central" property are linked to Central,
// everything else can be ignored
function parseEvoCentralInstances(discovery?: APIDiscoveryV2): EvoCentralInstance[] {
    const parsed: EvoCentralInstance[] = [];
    for (const account of discovery?.accounts ?? []) {
        for (const instance of account.instances ?? []) {
            const { central } = instance;
            if (central?.id) {
                parsed.push({
                    centralInstanceUUID: central.id,
                    centralDisplayName: central.display_name,
                    centralName: central.name,
                    centralHost: central.host,
                    centralOrganizationName: central.organization_name,
                });
            }
        }
    }
    return parsed;
}

export const DiscoveryApi = DiscoveryApiClient.injectEndpoints({
    endpoints: (build) => ({
        loadEvoCentralInstances: build.query<EvoCentralInstances, void>({
            query: () => ({
                url: '/evo/identity/v2/discovery?service=evo&service=central',
            }),
            transformResponse: (response: APIDiscoveryV2Response) => ({
                instances: parseEvoCentralInstances(response.discovery),
            }),
            async onQueryStarted(_arg, { queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    setEvoCentralInstances(data);
                } catch {
                    // Request failed - leave stored instances untouched
                }
            },
        }),
    }),
});

export const { useLoadEvoCentralInstancesQuery } = DiscoveryApi;
